import { getErrorPageFromStatusCode } from '@citrite/workspace-ui-platform';
import { ErrorPageNames, ErrorPageNamesForOnPrem } from 'staticPages/errorPages';

export function getErrorPageUrlForLanguage(
	errorPage: ErrorPageNames | ErrorPageNamesForOnPrem
) {
	// getErrorPageFromStatusCode publicly supports http status code error pages and unofficially supports other legacy error pages
	return getErrorPageFromStatusCode(errorPage as any);
}
